module.exports = __webpack_public_path__ + "static/landscape-stair-summer-57bfdb6ef4264ea62d311e9293bce7b2.jpg";